import React from 'react';

export default function Block6Implementation() {
  return (
    <section className="bg-paper py-16 md:py-24 px-4 md:px-16" id="evidencia">
      <div className="max-w-[600px] mx-auto flex flex-col items-start w-full">
        <div className="mb-16 md:mb-24 max-w-2xl px-2">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-4">
            Ecosistema Técnico
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink leading-[1.2] tracking-tight mb-6">
            Se integra a la operación existente. No crea una APS paralela.
          </h2>
          <p className="text-[16px] md:text-[18px] text-ink-soft leading-[1.6]">
            Encontrar riesgo no bastaba. La experiencia en terreno demostró que BAC no termina cuando identifica el riesgo, sino que coordina hasta que la siguiente acción efectivamente ocurre en la red.
          </p>
        </div>
        <div className="max-w-2xl mx-auto flex flex-col items-center w-full px-2">
          <div className="w-full flex flex-col items-center border border-line bg-surface py-6 rounded-xl">
            <div className="text-[12px] font-bold text-ink-soft/70 uppercase tracking-widest">SISTEMAS DE LA RED</div>
          </div>
          <div className="text-ink-soft/30 py-3">↓</div>
          <div className="w-full bg-[#ccccff] text-ink py-8 rounded-xl shadow-sm text-center border border-brand/20">
            <div className="text-[20px] font-bold tracking-widest">BAC CAPA OPERACIONAL</div>
          </div>
          <div className="text-ink py-3">↓</div>
          <div className="w-full flex flex-col items-center border-2 border-brand bg-surface py-6 rounded-xl">
            <div className="text-[12px] font-bold text-brand uppercase tracking-widest">EQUIPOS Y EJECUCIÓN APS</div>
          </div>
        </div>
        <div className="max-w-2xl mx-auto w-full mt-16 text-center text-[12px] font-medium text-ink-soft/50 uppercase tracking-widest border-t border-line pt-8">
          Alineado a MAIS · ECICEP · IAAPS
        </div>
      </div>
    </section>
  );
}
